define.alias("shared/components/shared/contact-us-modal", "settings/components/shared/contact-us-modal");